import { useState } from "react";
import { Settings, Play } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Slider } from "@/components/ui/slider";
import { getVolumes, setVolume, initAudio, doorSound, scare } from "@/game/audio";

const CHANNELS = [
  { key: "storm", label: "Storm", hint: "Wind & blizzard" },
  { key: "effects", label: "Effects", hint: "Footsteps, doors, fire, clock", preview: () => doorSound() },
  { key: "scares", label: "Scares", hint: "Random creaks & knocks", preview: scare },
];

const VolumeRow = ({ ch, value, onChange }) => (
  <div className="mb-5 last:mb-0" data-testid={`volume-row-${ch.key}`}>
    <div className="flex items-center justify-between mb-2">
      <div>
        <p className="pixel-text text-xl text-[#F3F4F6] leading-none">{ch.label}</p>
        <p className="pixel-text text-base text-[#64748B]">{ch.hint}</p>
      </div>
      <div className="flex items-center gap-2">
        <span className="pixel-text text-lg text-[#F59E0B] w-10 text-right" data-testid={`volume-value-${ch.key}`}>{Math.round(value * 100)}</span>
        {ch.preview && (
          <button className="text-[#9CA3AF] hover:text-[#F3F4F6] transition-colors p-1" onClick={() => { initAudio(); ch.preview(); }}
            aria-label={`Preview ${ch.label}`} data-testid={`volume-preview-${ch.key}`}><Play size={14} /></button>
        )}
      </div>
    </div>
    <Slider className="horror-slider" min={0} max={100} step={1} value={[Math.round(value * 100)]}
      onValueChange={([v]) => onChange(v / 100)} data-testid={`volume-slider-${ch.key}`} />
  </div>
);

export const SoundSliders = () => {
  const [vols, setVols] = useState(getVolumes());
  const change = (key, v) => { setVolume(key, v); setVols((s) => ({ ...s, [key]: v })); };
  return CHANNELS.map((ch) => <VolumeRow key={ch.key} ch={ch} value={vols[ch.key]} onChange={(v) => change(ch.key, v)} />);
};

export const SoundSettings = () => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="pixel-btn ghost flex items-center gap-2" data-testid="game-settings-button" aria-label="Sound settings">
          <Settings size={14} /><span className="hidden sm:inline">Settings</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 rounded-none bg-[#12141C] border-2 border-[#2E3440] shadow-[6px_6px_0_#000] p-5" data-testid="sound-settings-panel">
        <p className="pixel-text text-base text-[#7DD3FC] tracking-widest mb-4">// SOUND SETTINGS</p>
        <SoundSliders />
      </PopoverContent>
    </Popover>
  );
};
